export default "__VITE_PUBLIC_ASSET__fcc24d34__"